import { useEffect, useState } from "react";
import style from "./PhoneNumberCell.module.scss";
import { IProxy } from "@interfaces/admin/proxy";
import { Chip, CopyElement } from "@ui";
import { addRowError, removeRowError } from "@global-state/pages/admin/myProxies/slice";
import { useUpdateProxyDataMutation } from "@RTKQuery/admin/proxy/proxy";
import { useAppSelector, useAppDispatch } from "store/hooks";
import { IoClose } from "react-icons/io5";
import cn from "classnames";

export function PhoneNumberCell({
  dataPhone,
  proxy
}: {
  dataPhone: IProxy["phone_number"],
  proxy: IProxy | IProxy["children"][0]
}) {
  const [inputPhone, setInputPhone] = useState("");
  const [mode, setMode] = useState<"edit" | "read">("read")

  const formatPhoneNumber = (value: string) => {
    const numericValue = value.replace(/[^0-9-]/g, "");

    let formattedValue = "";

    if (numericValue.length > 0) {
      formattedValue = "+" + numericValue.slice(0, 2).replace(/-/g, "");
    }
    if (numericValue.length > 2) {
      formattedValue += " (" + numericValue.slice(2, 5).replace(/-/g, "");
    }
    if (numericValue.length > 5) {
      formattedValue += ") " + numericValue.slice(5, 6).replace(/-/g, "") + numericValue.slice(6);
    }

    return formattedValue.replace(/(-)\1+/g, "-");;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    const formattedValue = formatPhoneNumber(inputValue);

    setInputPhone(formattedValue);
  };

  useEffect(() => {
    setInputPhone(dataPhone || "")
  }, [dataPhone])

  const [updateProxyData, { isError, isSuccess, reset }] = useUpdateProxyDataMutation();

  const {activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling} = useAppSelector(state => state.myProxiesAdminPage);

  const rowsIsError = useAppSelector(state => state.myProxiesAdminPage.rowsIsError)?.[proxy.id] || [];

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isSuccess) {
      dispatch(removeRowError({
        proxyId: proxy.id,
        colName: "phone_number"
      }))
    }
  }, [isSuccess])

  return (
    <div className={style.cell}>
      {
        dataPhone && mode === "read"
          ? <CopyElement
            element={
              <p
                className="text-[#1B1B1D] whitespace-nowrap text-[13px] font-medium select-none"
                onClick={() => {
                  setMode("edit");
                }}
              >
                {dataPhone}
              </p>
            }
            copyText={String(dataPhone)}
          />
          : <input
            type="text"
            autoFocus={Boolean(dataPhone) && (mode === "edit")}
            className={style.input}
            value={inputPhone}
            onChange={handleInputChange}
            placeholder="Додати телефон"
            onBlur={() => {
              setMode("read");
              if (inputPhone) {
                updateProxyData({
                  proxy_id: proxy.id,
                  parent_id: proxy.parent_id || undefined,
                  params: {
                    page: activePaginationPage,
                    limit: activePaginationLimit,
                    router_id: activeSearchIdParameter,
                    operator: activeOperator,
                    phone_number: activeSearchPhoneParameter,
                    selling: activeSelling
                  },
                  body: {
                    phone_number: inputPhone
                  }
                })
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                setMode("read");
                if (inputPhone) {
                  updateProxyData({
                    proxy_id: proxy.id,
                    parent_id: proxy.parent_id || undefined,
                    params: {
                      page: activePaginationPage,
                      limit: activePaginationLimit,
                      router_id: activeSearchIdParameter,
                      operator: activeOperator,
                      phone_number: activeSearchPhoneParameter,
                      selling: activeSelling
                    },
                    body: {
                      phone_number: inputPhone
                    }
                  })
                }
              }
            }}
          />
      }
      <div className={cn("absolute left-full z-10 top-1/2 pl-[5px] -translate-y-1/2", rowsIsError.includes("phone_number") ? "block" : "hidden")}>
        <Chip
          text="Помилка"
          color="red"
          icon={<IoClose
            className="w-[15px] text-[#F81F1F] h-[15px] cursor-pointer"
            onClick={() => {
              reset();
              dispatch(removeRowError({
                proxyId: proxy.id,
                colName: "phone_number"
              }))
            }}
          />}
          aligtIcon="right"
        />
      </div>
    </div>
  )
}
